import { Paper, Typography } from '@mui/material';
import RTO_app from '../../static/RBCRTOWORKSHEET.pdf';
import QR from '../../static/QR_BCCapital.png';


const RTOBCCapitalCard = () => {  
  return (
    <Paper
    sx={{
        backgroundColor: '#F8F5EB',
        borderTop: 3,
        borderColor: 'divider',
        padding: '0.5em',
        margin: '1.5em 0',
        width: '100%',
        maxWidth: '800px'
    }}>

        <Typography
        variant='h4'
        >BC Capital RTO</Typography>

        <ul id='finance-app-list'>
          <li>Scan our QR code
              <br></br>
              <img
              src={QR}
              alt="qr code for hometowne finance"
              width={'200px'} />
          </li>
          -or-
          <li><a href={RTO_app} download>Download our BC Capital RTO application</a></li>
        </ul>

    </Paper>
  )
}

export default RTOBCCapitalCard;